import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarChart3, Crown } from "lucide-react";
import { API } from "@/lib/gp";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/leaderboard`).then((r) => r.json()).then((d) => setRows(d.leaderboard || [])).catch(() => {});
  }, []);

  const medal = ["text-gp-gold", "text-white/70", "text-[#cd7f32]"];

  return (
    <div className="mx-auto max-w-3xl px-5 md:px-8 py-12 md:py-16">
      <div className="flex items-center gap-3 mb-2">
        <BarChart3 className="text-gp-blue" size={26} />
        <h1 className="font-unbounded font-black tracking-tighter text-4xl uppercase">Leaderboard</h1>
      </div>
      <p className="text-white/60 mb-8">Earn 3 points for every verified tournament win.</p>

      {rows.length === 0 ? (
        <div className="glass rounded-2xl p-10 text-center text-white/50" data-testid="leaderboard-empty">
          No ranked players yet. Verified wins from the December 12 Community Challenge will fill this board.
        </div>
      ) : (
        <div className="glass rounded-2xl divide-y divide-white/10" data-testid="leaderboard-list">
          {rows.map((p, i) => (
            <button key={p.user_id} onClick={() => navigate(`/players/${p.user_id}`)} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-white/5 transition-colors text-left">
              <span className={`w-8 text-center font-unbounded font-black text-lg ${medal[i] || "text-white/40"}`}>{i < 3 ? <Crown size={18} className="inline" /> : i + 1}</span>
              {p.picture ? <img src={p.picture} alt="" className="h-9 w-9 rounded-full object-cover" /> : <span className="grid place-items-center h-9 w-9 rounded-full bg-gp-blue/20 text-gp-blue font-bold">{(p.name || "?").slice(0, 1).toUpperCase()}</span>}
              <span className="flex-1 font-semibold truncate">{p.name || "Player"}</span>
              <span className="font-unbounded font-black text-gp-blue">{p.points} <span className="text-xs text-white/40 font-sans">pts</span></span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
